import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import MediaModal from "../PagesSection/Component/MediaModal";
import { imageBaseApi } from "../../utilis/imageHelper";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import MediaService from "../../services/KangarooServices/MediaServices";
import HomeService from "../../services/KangarooServices/HomeServices";

const BannerForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [mediaData, setMediaData] = useState([]);
  const [details, setDetails] = useState(null);

  const toggleMedia = () => {
    setIsMediaOpen(!isMediaOpen);
  };

  const fetchMedia = async (page = 1, size = 1000) => {
    try {
      const response = await MediaService.getList({ page, pageSize: size });
      setMediaData(response);
      return response;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
  console.log("hehjeh", mediaData);

  const fetchDetail = async () => {
    if (!id) return;
    try {
      const result = await HomeService.getdetails(id);
      setDetails(result);

      // Populate selected media from existing data

      if (result.mediaId) {
        // First check if mediaItems array exists in response
        if (result.mediaItems && result.mediaItems.length > 0) {
          const media = result.mediaItems.find((m) => m.id === result.mediaId);
          if (media) {
            console.log("Found media in mediaItems:", media);
            setSelectedMedia(media);
          }
        } else {
          // If mediaItems not in response, fetch from media list
          const mediaList = await fetchMedia();
          if (mediaList && mediaList.items) {
            const media = mediaList.items.find((m) => m.id === result.mediaId);
            if (media) {
              console.log("Found media in mediaList:", media);
              setSelectedMedia(media);
            }
          }
        }
      }
      // if (result.mediaId) {
      //   setSelectedMedia({
      //     id: result.mediaId,
      //     url: result.media?.url || "",
      //     mimeType: result.media?.mimeType || "",
      //     fileName: result  .media?.fileName || "",
      //   });
      // }
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch section details");
    }
  };

  useEffect(() => {
    fetchMedia();
  }, []);

  useEffect(() => {
    if (id) {
      fetchDetail();
    }
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      sectionName: details?.sectionName || "",
      orderIndex: details?.orderIndex || 0,
      description: details?.description || "",
      buttonText: details?.buttonText || "",
      mediaId: details?.mediaId || null,
    },
    validationSchema: Yup.object({
      sectionName: Yup.string().required("Section name is required"),
      orderIndex: Yup.number()
        .required("Order Index is required")
        .min(0, "Order Index must be at least 0"),
      description: Yup.string(),
      buttonText: Yup.string(),
    }),
    onSubmit: async (values) => {
      console.log("Submitting values:", values);
      console.log("Selected media:", selectedMedia);

      try {
        setLoading(true);
        const payload = {
          sectionName: values.sectionName,
          orderIndex: values.orderIndex,
          description: values.description,
          buttonText: values.buttonText,
          mediaId: selectedMedia?.id || null,
        };

        console.log("Payload to send:", payload);

        if (id) {
          // Update existing section
          await HomeService.update(id, payload);
          toast.success("Section updated successfully!");
        } else {
          // Create new section
          await HomeService.create(payload);
          toast.success("Section created successfully!");
        }
        navigate("/homesection"); // Update this path as needed
      } catch (error) {
        console.error("API ERROR:", error.response?.data || error);
        toast.error(error.response?.data?.message || "Failed to save section");
      } finally {
        setLoading(false);
      }
    },
  });

  // Handle media selection from modal
  const handleMediaSelect = (media) => {
    setSelectedMedia(media);
    setIsMediaOpen(false);
  };

  const breadcrumbItems = [
    { title: "Back to List", link: "/homesection" }, // Update this path as needed
  ];

  console.log("Hellllo", selectedMedia);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={id ? "Edit Section" : "Create Section"}
          pageTitle="Home Sections"
          breadcrumbItems={breadcrumbItems}
        />

        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-end gap-3 mb-3">
            <Button type="submit" color="success" disabled={loading}>
              {loading ? "Submitting..." : id ? "Update" : "Create"}
            </Button>
            <Button
              type="button"
              color="danger"
              onClick={() => navigate(`/homesection/${id}`)} // Update this path as needed
              disabled={loading}
            >
              Cancel
            </Button>
          </div>

          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  {/* Section Name */}
                  <div className="mb-3">
                    <Label>
                      Section Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      name="sectionName"
                      value={formik.values.sectionName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Enter Section Name"
                    />
                    {formik.touched.sectionName &&
                      formik.errors.sectionName && (
                        <div className="text-danger mt-1">
                          {formik.errors.sectionName}
                        </div>
                      )}
                  </div>

                  {/* Order Index */}
                  <div className="mb-3">
                    <Label>
                      Order Index <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="number"
                      name="orderIndex"
                      value={formik.values.orderIndex}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Enter Order Index"
                    />
                    {formik.touched.orderIndex && formik.errors.orderIndex && (
                      <div className="text-danger mt-1">
                        {formik.errors.orderIndex}
                      </div>
                    )}
                  </div>

                  {/* Button Text */}
                  <div className="mb-3">
                    <Label>Button Text</Label>
                    <Input
                      name="buttonText"
                      value={formik.values.buttonText}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Enter Button Text (e.g., Get Started)"
                    />
                    {formik.touched.buttonText && formik.errors.buttonText && (
                      <div className="text-danger mt-1">
                        {formik.errors.buttonText}
                      </div>
                    )}
                  </div>

                  {/* Description with CKEditor */}
                  <div className="mb-3">
                    <Label>Description</Label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formik.values.description}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        formik.setFieldValue("description", data);
                      }}
                      onBlur={() => formik.setFieldTouched("description", true)}
                    />
                    {formik.touched.description &&
                      formik.errors.description && (
                        <div className="text-danger mt-1">
                          {formik.errors.description}
                        </div>
                      )}
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg={4}>
              <Card>
                <CardBody>
                  {/* Media Selection */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <Label>Media</Label>
                    <Button
                      type="button"
                      color="success"
                      size="sm"
                      onClick={toggleMedia}
                    >
                      {selectedMedia ? "Change" : "Add"}
                    </Button>
                  </div>

                  {selectedMedia ? (
                    <div className="mt-2 text-center">
                      {selectedMedia.mimeType?.startsWith("image") && (
                        <img
                          src={`${imageBaseApi}${selectedMedia?.url}`}
                          alt={selectedMedia.fileName}
                          style={{
                            maxHeight: "200px",
                            maxWidth: "100%",
                            borderRadius: "6px",
                          }}
                        />
                      )}
                      {selectedMedia.mimeType === "application/pdf" && (
                        <a
                          href={selectedMedia.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="d-block mt-2"
                        >
                          📄 {selectedMedia.fileName}
                        </a>
                      )}
                      {!selectedMedia.mimeType?.startsWith("image") &&
                        selectedMedia.mimeType !== "application/pdf" && (
                          <span className="d-block mt-2">
                            ❓ {selectedMedia.fileName}
                          </span>
                        )}
                      <div className="mt-2">
                        <small className="text-muted">
                          {selectedMedia.fileName}
                        </small>
                      </div>
                    </div>
                  ) : (
                    <p className="text-muted mt-2 text-center small">
                      No media selected
                    </p>
                  )}
                </CardBody>
              </Card>

              {/* Preview Card */}
              {/* <Card>
                <CardBody>
                  <h6 className="mb-3">Preview</h6>
                  <div className="border rounded p-3">
                    <p className="mb-2">
                      <strong>Section:</strong> {formik.values.sectionName || "N/A"}
                    </p>
                    <p className="mb-2">
                      <strong>Order:</strong> {formik.values.orderIndex}
                    </p>
                    {formik.values.buttonText && (
                      <p className="mb-2">
                        <strong>Button:</strong> {formik.values.buttonText}
                      </p>
                    )}
                    {formik.values.description && (
                      <div className="mb-0">
                        <strong>Description:</strong>
                        <div
                          className="mt-1 small"
                          dangerouslySetInnerHTML={{
                            __html: formik.values.description,
                          }}
                        />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card> */}
            </Col>
          </Row>
        </form>

        <MediaModal
          isOpen={isMediaOpen}
          toggle={() => setIsMediaOpen(!isMediaOpen)}
          mediaData={mediaData}
          selectedMedia={selectedMedia}
          setSelectedMedia={handleMediaSelect}
        />
      </Container>
    </div>
  );
};

export default BannerForm;
